import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import document from "../../assets/images/document.png";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const ImageDropzone = ({ oldImages = [], setFiles, updateOldImages }) => {
  const [acceptedFile, setAcceptedFile] = useState(null);
    const { t, i18n } = useTranslation();
          const isRTL = i18n.language === 'ar';
  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    onDrop: (acceptedFilesList, fileRejections) => {
      if (fileRejections.length > 0) {
        fileRejections.forEach((rejection) => {
          rejection.errors.forEach((err) => {
            if (err.code === "file-too-large") {
              toast.error(t("file_too_large") || `File ${rejection.file.name} is too large. Max size is 5MB.`);
            } else if (err.code === "file-invalid-type") {
              toast.error(t("file_invalid_type") || `File ${rejection.file.name} has invalid type.`);
            } else {
              toast.error(err.message);
            }
          });
        });
      }

      if (acceptedFilesList.length > 0) {
        const fileWithPreview = {
          file: acceptedFilesList[0],
          preview: URL.createObjectURL(acceptedFilesList[0]),
        };
        setAcceptedFile(fileWithPreview);
        setFiles([fileWithPreview.file]);
      }
    },
    maxSize: 5 * 1024 * 1024,
    multiple: false,
    accept: {
      'image/*': [],
      'application/pdf': [],
      'application/msword': [],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [], // .docx
    },
    noClick: !!acceptedFile || oldImages.length > 0, 
    noKeyboard: !!acceptedFile || oldImages.length > 0,
  });

  const removeFile = () => {
    if (acceptedFile) {
      URL.revokeObjectURL(acceptedFile.preview);
    }
    setAcceptedFile(null);
    setFiles([]);
  };

  const removeDBFile = (nameToRemove) => {
    const updatedOldImages = oldImages.filter((image) => image !== nameToRemove);
    updateOldImages(updatedOldImages);
  };

  useEffect(() => {
    return () => {
      if (acceptedFile) {
        URL.revokeObjectURL(acceptedFile.preview);
      }
    };
  }, [acceptedFile]);

  const showDropzone = !acceptedFile && oldImages.length === 0;

  return (
<div>
  {showDropzone ? (
    <div {...getRootProps()} className="inter-font dropzone">
      <input {...getInputProps()} />
      <p>
        {isDragActive ? (
          t("drop_file_here")
        ) : (
          <img src={document} className="inter-font docImg" />
        )}
      </p>
      <h5 className="inter-font doc-font" style={{ textAlign: "center" }}>
        {t("c_ff_text63")}
      </h5>
      <p
        className="text-muted small"
        style={{ textAlign: "center", fontSize: "12px" }}
      >
        {t("document_requirements")}
      </p>
    </div>
  ) : null}

  <div className="inter-font previews bg-light">
    {oldImages.map((image, index) => (
      <div key={`old-${index}`} className="inter-font preview-item">
        <img src={image} alt="Preview" className="inter-font preview-image" />
        <button
          type="button"
          onClick={() => removeDBFile(image)}
          className="inter-font remove-button"
        >
          X
        </button>
      </div>
    ))}

    {acceptedFile && (
      <div className="inter-font preview-item">
        {acceptedFile.file.type.startsWith("image/") ? (
          <img
            src={acceptedFile.preview}
            alt="Preview"
            className="inter-font preview-image"
          />
        ) : acceptedFile.file.type === "application/pdf" ? (
          <iframe
            src={acceptedFile.preview}
            title="PDF Preview"
            className="inter-font preview-pdf"
            width="100%"
            height="150px"
          />
        ) : (
          <div className="inter-font doc-placeholder">
            <img src={document} alt="Document Icon" className="docImg-small" />
            <span style={{ textAlign: isRTL ? "right" : "left" }}>{acceptedFile.file.name}</span>
            <p style={{ textAlign: isRTL ? "right" : "left" }}>{t("preview_not_supported")}</p>
          </div>
        )}
        <button
          type="button"
          onClick={removeFile}
          className="inter-font remove-button"
        >
          X
        </button>
      </div>
    )}
  </div>
</div>
  );
};

export default ImageDropzone;
